import React from "react";

// import dayjs from "dayjs";
import { s360ConfigService } from "../../Services/S360Config";
import MessageA1 from "../MessageCodes/MessageA1";
import MessageA1i from "../MessageCodes/MessageA1i";
import MessageA2 from "../MessageCodes/MessageA2";
import MessageA3 from "../MessageCodes/MessageA3";
import MessageA3f from "../MessageCodes/MessageA3f";
import MessageA4 from "../MessageCodes/MessageA4";
import MessageA5 from "../MessageCodes/MessageA5";
import MessageA6 from "../MessageCodes/MessageA6";
import MessageA7 from "../MessageCodes/MessageA7";
import MessageA13 from "../MessageCodes/MessageA13";
import MessageA14 from "../MessageCodes/MessageA14";
import MessageA15 from "../MessageCodes/MessageA15";
import MessageA19 from "../MessageCodes/MessageA19";
import MessageA20 from "../MessageCodes/MessageA20";
import MessageA21 from "../MessageCodes/MessageA21";
import MessageA56 from "../MessageCodes/MessageA56";
import MessageA77 from "../MessageCodes/MessageA77";
import MessageA78 from "../MessageCodes/MessageA78";
import MessageA79 from "../MessageCodes/MessageA79";
import MessageA96 from "../MessageCodes/MessageA96";
import MessageA97 from "../MessageCodes/MessageA97";
import MessageA98 from "../MessageCodes/MessageA98";
import MessageA99 from "../MessageCodes/MessageA99";
import Redirect from "../MessageCodes/Redirect";

function CustomMessage(props) {
  // "uiCommand": "A1",
  // "text": "Text(A3)",
  // "keyword": "1",
  // "code": "1.1"

  // const showMessageTime = () => {
  //   return props.message.type !== MessageType.info;
  // };

  // const messageTimeClassName = () => {
  //   console.log('custommessage')
  //   switch (props.message.type) {
  //     case MessageType.info:
  //       return "s360-message-time-info";
  //     default:
  //       return "";
  //   }
  // };

  const getMessageComponent = (entry, index, isLastEntry, sentTimestamp) => {
    let commandType = entry.uiCommand; //"A56";//

    switch (commandType) {
      case UICommandType.A1:
        return (
          <MessageA1
            disabled={props.disabled}
            key={"message-a1-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A1i:
        return (
          <MessageA1i
            disabled={props.disabled}
            key={"message-a1i-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A2:
        return (
          <MessageA2
            disabled={props.disabled}
            key={"message-a2-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A3:
        return (
          <MessageA3
            disabled={props.disabled}
            key={"message-a3-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A3f:
        return (
          <MessageA3f
            disabled={props.disabled}
            key={"message-a3f-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A4:
        return (
          <MessageA4
            disabled={props.disabled}
            key={"message-a4-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A5:
        return (
          <MessageA5
            disabled={props.disabled}
            key={"message-a5-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A6:
        return (
          <MessageA6
            disabled={props.disabled}
            key={"message-a6-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A13:
        return (
          <MessageA13
            disabled={props.disabled}
            key={"message-a13-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
            scrollToLatest={props.scrollToLatest}
          />
        );
      case UICommandType.A14:
        return (
          <MessageA14
            disabled={props.disabled}
            scrollToLatest={props.scrollToLatest}
            key={"message-a14-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A15:
        return (
          <MessageA15
            disabled={props.disabled}
            key={"message-a15-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A19:
        return (
          <MessageA19
            disabled={props.disabled}
            key={"message-a19-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A20:
        return (
          <MessageA20
            disabled={props.disabled}
            key={"message-a20-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A21:
        return (
          <MessageA21
            disabled={props.disabled}
            key={"message-a21-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A56:
        return (
          <MessageA56
            disabled={props.disabled}
            key={"message-a56-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A77:
        return (
          <MessageA77
            disabled={props.disabled}
            key={"message-a77-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A78:
        return (
          <MessageA78
            disabled={props.disabled}
            key={"message-a78-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A96:
        return (
          <MessageA96
            disabled={props.disabled}
            key={"message-a-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A97:
        return (
          <MessageA97
            disabled={props.disabled}
            key={"message-a97-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A7:
        return (
          <MessageA7
            disabled={props.disabled}
            key={"message-a7-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A98:
        return (
          <MessageA98
            disabled={props.disabled}
            key={"message-a98-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.A99:
        return (
          <MessageA99
            disabled={props.disabled}
            key={"message-a99-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      case UICommandType.Redirect:
        return (
          <Redirect
            disabled={props.disabled}
            key={"message-redirect-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );

      case UICommandType.A79:
        return (
          <MessageA79
            disabled={props.disabled}
            key={"message-a79-" + index}
            entry={entry}
            entryIndex={index}
            isLastEntry={isLastEntry}
            sentTimestamp={sentTimestamp}
            {...props}
          />
        );
      // closedSession:"closedSession",
      // transferSession:"transferSession"
      default:
        return <></>;
    }
  };

  const messageEntries =
      (props.message.message.chatResponse &&
        props.message.message.chatResponse.entries) ||
      [];
  const sentTimestamp = props.message.message.sentTimestamp;

  return (
    <div
      className={`s360-dynamic-buttons${localStorage.getItem("openInFullScreen") ? "-fs" : ""}`}
      style={{
        width: s360ConfigService.config?.customDesign?.dynamicButtons?.flexDirection === 'column' ? "85%" : "100%",
        ...s360ConfigService.config?.customDesign?.dynamicButtons,
      }}
    >
      {messageEntries.map((entry, index, allEntries) => {
        return getMessageComponent(
          entry,
          index,
          allEntries.length === index,
          sentTimestamp
        );
      })}
      {/*{sentTimestamp && (*/}
      {/*  <div className={messageTimeClassName()}>*/}
      {/*    {dayjs*/}
      {/*      .unix(Math.trunc(sentTimestamp / 1000))*/}
      {/*      .format("DD MMM h:mm a")}*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
}

export const UICommandType = {
  A1: "A1",
  A1i: "A1i",
  A2: "A2",
  A3: "A3",
  A3f: "A3f",
  A4: "A4",
  A5: "A5",
  A6: "A6",
  A7: "A7",
  A10: "A10",
  A13: "A13",
  A14: "A14",
  A15: "A15",
  A19: "A19",
  A20: "A20",
  A21: "A21",
  A24: "A24",
  A56: "A56",
  A78: "A78",
  A79: "A79",
  A77: "A77",
  A96: "A96",
  A97: "A97",
  A98: "A98",
  A99: "A99",
  Redirect: "Redirect",
  closedSession: "closedSession",
  transferSession: "transferSession",
};

export const MessageType = {
  received: "RECEIVED",
  sent: "SENT",
  info: "INFO",
};

export default CustomMessage;
